<template>
    <div class="testing">
        <div class="header_wrap">
            <div class="header_wrap_content">
                <div class="avatar text_center">
                    <img :src="user && user.photo?user.photo+'?x-oss-process=style/w128-h128':default_head" alt="">
                </div>
                <div class="test_tips text_center">{{user && user.user_name?user.user_name:''}}, 恭喜你完成此次考试</div>
                <div class="test_grade">
                    <div class="text_center" v-if="user_status==3" ><span class="test_grade_score">{{user_score}}</span> 分</div>
                    <div class="text_center" v-if="user_status==2"><span class="test_grade_commenting">批阅中</span></div>
                </div>
                <div class="test_commit_time text_center">本次考试提交时间：{{user_answer_time_cn}}</div>
            </div>
        </div>
        <div class="content">
            <div v-for="(item,index) in test_questions" :key="index">
                <div v-if="item.question_info.question_type==3" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(判断题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <van-radio-group v-model="item.user_answer">
                            <div class="question_item_option" ><span :class="['iconfont', item.icons.zhengque]"></span><van-radio disabled name="1" :icon-size="icon_size" >正确</van-radio></div>
                            <div class="question_item_option" ><span :class="['iconfont', item.icons.cuowu]"></span><van-radio disabled name="0" :icon-size="icon_size" >错误</van-radio></div>
                        </van-radio-group>
                    </div>
                    <van-divider />
                    <div class="question_evaluate">
                        <div class="question_result">
                            <span v-if="item.question_info.user_is_true" class="question_result_tips question_text_weight color_green" >回答正确</span> 
                            <span v-if="!item.question_info.user_is_true" class="question_result_tips question_text_weight color_red" >回答错误</span> 
                            <span class="question_result_scores font_size_11">(得分：{{item.question_info.user_score}}分)</span>
                        </div>
                        <div class="question_refer">
                            <div class="question_text_weight">正确答案</div>
                            <div class="font_size_11" >{{item.suggest_answer}}</div>
                        </div>
                        <div>
                            <div class="question_text_weight">解析</div>
                            <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                        </div>
                    </div>
                    
                </div>
                <div v-if="item.question_info.question_type==1" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(单选题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <van-radio-group v-model="item.user_answer">
                            <div v-for="(options_item,options_index) in item.question_info.question_options" 
                            :key="options_index" 
                            class="question_item_option" 
                            >
                                <span v-if="item.user_answer==options_item.question_options_id && options_item.is_true" class="iconfont icondui "></span>
                                <span v-else-if="item.user_answer==options_item.question_options_id && !options_item.is_true" class="iconfont iconcuo "></span>
                                <span v-else class="iconfont iconkongbai "></span>
                                <van-radio disabled :name="options_item.question_options_id" :icon-size="icon_size" >{{options_cn[options_index]}}.{{options_item.options}}</van-radio>
                        </div>
                        </van-radio-group>
                    </div>
                    <van-divider />
                    <div class="question_evaluate">
                        <div class="question_result">
                            <span v-if="item.question_info.user_is_true" class="question_result_tips question_text_weight color_green" >回答正确</span> 
                            <span v-if="!item.question_info.user_is_true" class="question_result_tips question_text_weight color_red" >回答错误</span>
                            <span class="question_result_scores font_size_11">(得分：{{item.question_info.user_score}}分)</span>
                        </div>
                        <div class="question_refer">
                            <div class="question_text_weight">正确答案</div>
                            <div class="font_size_11" >{{item.suggest_answer}}</div>
                        </div>
                        <div>
                            <div class="question_text_weight">解析</div>
                            <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                        </div>
                    </div>
                </div>

                <div v-if="item.question_info.question_type==2" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(多选题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <van-checkbox-group v-model="item.user_answer">
                            <div 
                                v-for="(options_item,options_index) in item.question_info.question_options" 
                                :key="options_index" 
                                class="question_item_option" 
                            >
                                <span v-if="item.user_answer.indexOf(options_item.question_options_id)!=-1 && options_item.is_true" class="iconfont icondui "></span>
                                <span v-else-if="item.user_answer.indexOf(options_item.question_options_id)!=-1 && !options_item.is_true" class="iconfont iconcuo "></span>
                                <span v-else class="iconfont iconkongbai "></span>
                                <van-checkbox disabled :name="options_item.question_options_id" :icon-size="icon_size" shape="square">{{options_cn[options_index]}}.{{options_item.options}}</van-checkbox>
                            </div>
                         </van-checkbox-group>
                    </div>
                    <van-divider />
                    <div class="question_evaluate">
                        <div class="question_result">
                            <span v-if="item.question_info.user_is_true" class="question_result_tips question_text_weight color_green" >回答正确</span> 
                            <span v-if="!item.question_info.user_is_true" class="question_result_tips question_text_weight color_red" >回答错误</span>
                            <span class="question_result_scores font_size_11">(得分：{{item.question_info.user_score}}分)</span>
                        </div>
                        <div class="question_refer">
                            <div class="question_text_weight">参考答案</div>
                            <div class="font_size_11" >{{item.suggest_answer?item.suggest_answer:'暂无'}}</div>
                        </div>
                        <div>
                            <div class="question_text_weight">解析</div>
                            <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                        </div>
                    </div>
                </div>

                <div v-if="item.question_info.question_type==4" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(填空题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <div 
                            v-for="(options_item,options_index) in item.question_info.question_options" 
                            :key="options_index"   
                            class="question_item_option" 
                        >
                            <span class="iconfont iconkongbai"></span>
                            <van-field 
                                disabled
                                :label-width="label_width" 
                                :name="options_item.question_options_id"  
                                v-model="item.user_answer[options_index]" 
                                :label="options_index+1" 
                                placeholder='请输入你回答' 
                            />
                        </div>
                    </div>
                    <van-divider />
                    <div class="question_evaluate">
                        <div class="question_result">
                            <span class="question_result_tips question_text_weight" >评分结果</span> 
                            <span class="question_result_scores font_size_11">(得分：{{user_status==3 && item.question_info.user_score+'分'?item.question_info.user_score:'评定中'}})</span>
                        </div>
                        <div class="question_refer">
                            <div class="question_text_weight">参考答案</div>
                            <div class="font_size_11" >{{item.suggest_answer?item.suggest_answer:'暂无'}}</div>
                        </div>
                        <div>
                            <div class="question_text_weight">解析</div>
                            <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                        </div>
                    </div>
                    <div>
                        <van-divider />
                        <div>
                            <div class="question_text_weight question_teacher_comment">老师评语</div>
                            <div class="font_size_11" >{{user_status==3 && item.question_info.user_comment?item.question_info.user_comment:'老师正在努力批阅中'}}</div>
                        </div>
                    </div>
                </div>

                <div v-if="item.question_info.question_type==5" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(问答题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <div>
                            <van-field
                                v-model="item.user_answer.text"
                                rows="5"
                                autosize
                                type="textarea"
                                placeholder="请填写你的回答"
                            />
                        </div>
                        <div>
                            <div v-if="essay_question_type==1" class="question_essay"  >
                                <div class="iconfont_wrap"><span class="iconfont iconcomiistupian mr5 size25"></span></div>
                                <div class="iconfont_wrap"><span class="iconfont iconyinpin mr5 size25"></span></div>
                            </div>
                            <div v-if="item.user_answer.images" class="question_essay_type_2">
                                <van-uploader 
                                    :ref="item.question_info.test_question_id" 
                                    v-model="item.user_answer.images" 
                                    multiple 
                                    :max-count="9" 
                                    :deletable="false"
                                    :show-upload="false"
                                />
                            </div>
                            <div v-if="item.user_answer.audio" style="padding:3px;">
                                <m-audio :src="item.user_answer.audio"></m-audio>
                            </div>
                        </div>
                    </div>
                    <van-divider />
                    <div class="question_evaluate">
                        <div class="question_result">
                            <span class="question_result_tips question_text_weight" >评分结果</span> 
                            <span class="question_result_scores font_size_11">(得分：{{user_status==3 && item.question_info.user_score+'分'?item.question_info.user_score:'评定中'}})</span>
                        </div>
                        <div class="question_refer">
                            <div class="question_text_weight">参考答案</div>
                            <div class="font_size_11" >{{item.suggest_answer?item.suggest_answer:'暂无'}}</div>
                        </div>
                        <div>
                            <div class="question_text_weight">解析</div>
                            <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                        </div>
                    </div>
                    <div>
                        <van-divider />
                        <div>
                            <div class="question_text_weight question_teacher_comment">老师评语</div>
                            <div class="font_size_11" >{{user_status==3 && item.question_info.user_comment?item.question_info.user_comment:'老师正在努力批阅中'}}</div>
                        </div>
                    </div>
                </div>

             </div>
            <div>
                <van-button type="info" @click="bindGotoStage" block>返回训练营</van-button>
            </div>
        </div>
        
    </div>
</template>

<script>
    import { List,PullRefresh,Form,Field,RadioGroup, Radio,Checkbox, CheckboxGroup,Button,Uploader, ActionSheet,CountDown,Empty,Dialog,Divider   } from 'vant';
    import audio from 'vue-mobile-audio'
    import Vue from 'vue'
    Vue.use(audio);
    export default {
        components:{
            [Form .name]:Form,
            [Field .name]:Field,
            [RadioGroup .name]:RadioGroup,
            [Radio .name]:Radio,
            [Checkbox .name]:Checkbox,
            [CheckboxGroup .name]:CheckboxGroup,
            [Button .name]:Button,
            [Uploader .name]:Uploader,
            [ActionSheet .name]:ActionSheet,
            [CountDown .name]:CountDown,
            [Empty .name]:Empty,
            [Dialog  .name]:Dialog ,
            [Divider .name]:Divider,
            [Audio .name]:Audio,
        },
        data() {
            return {
                radio: false,
                checked: [],
                test_id: '',
                study_id: '',
                training_id: '',
                stage_id: '',
                task_id: '',

                text: '',
                message:'',
                icon_size: "18px",
                label_width: '15px',
                essays:[],
                essay_question_images:[],
                essay_question_type:2,

                user:{},
                default_head:require('../../assets/icon/default_head.png'),
                user_status: 0,
                user_score: 0,
                user_answer_time_cn: '0000-00-00 00-00',

                test_question_num: 0,
                test_score: 0,
                test_empty: 0,
                test_questions: [],
                curr_questions_item:{},

                icons:{
                    defaulticon:'iconkongbai',
                    icondui:'icondui',
                    iconcuo:'iconcuo'
                },
                options_cn: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N']
            };
        },
        mounted() {
            this.user=this.user=this.util.globalData.user.get()
            this.test_id = this.$route.query.test_id
            this.study_id = this.$route.query.study_id
            this.getQuestion()
            this.get_stage_info()
        },
        methods: {
            bindGotoStage(){
               return this.$router.push(this.util.urlPrefix+'/training/phase?stage_id='+this.stage_id+'&task_id='+this.task_id+'&token='+this.util.token);
            },
            get_stage_info(){
                var _self=this
                this.util.server.mini_training.get_stage_info({
                    data:{
                        study_id: this.study_id,
                    },
                    callback:(res => {
                        console.log(res)
                        const { code, data, msg } = res;
                        this.training_id = data.training_id
                        this.stage_id = data.training_stage_id
                        this.task_id = data.training_task_id
                        
                    })
                })
            },
            getQuestion(){
                var _self=this;
                this.util.server.mini_testing.get_question({
                    data:{
                        test_id: this.test_id,
                        object_type: 1,
                        object_id: this.study_id,
                    },
                    callback:(res => {
                        if(res.data){
                            let datas = res.data;
                            console.log('length',datas.length)//data.items && data.items.length>0
                            if(datas && datas.test_info){
                                this.test_empty = 1
                                this.test_question_num = datas.test_question_num
                                this.test_score = datas.test_score
                                this.user_score = datas.user_score
                                this.user_status = datas.user_status
                                this.user_answer_time_cn = datas.user_answer_time_cn
                                
                                //init 初始化数据格式
                                //对于不同类型，需要初始化数据绑定
                                datas.test_info.forEach((value,index,array) => {
                                    console.log(value)
                                    value.suggest_answer = '';
                                    //单选题
                                    if(value.question_info.question_type==1){
                                        value.user_answer = value.question_info.user_question_answer
                                        
                                        value.question_info.question_options.forEach((v,i,arr) =>{
                                            if(v.is_true==1){
                                                value.suggest_answer = this.options_cn[i]
                                            }
                                        })
                                    }
                                    //多选题
                                    if(value.question_info.question_type==2){
                                        value.user_answer = value.question_info.user_question_answer
                                         let sug = []
                                        value.question_info.question_options.forEach((v,i,arr) =>{
                                            if(v.is_true==1){
                                                sug.push(this.options_cn[i])
                                            }
                                        })
                                        value.suggest_answer = sug.toString()
                                    }
                                    //判断题
                                    if(value.question_info.question_type==3){
                                        value.user_answer = value.question_info.user_question_answer
                                        let icon = {zhengque:this.icons.defaulticon, cuowu: this.icons.defaulticon}

                                        console.log('value.user_answer', value.user_answer)
                                        console.log('value.question_info.question_options[0].is_true',value.question_info.question_options[0].is_true)

                                        if(value.user_answer==1){
                                            icon.zhengque = value.user_answer==value.question_info.question_options[0].is_true?this.icons.icondui:this.icons.iconcuo
                                        }
                                        if(value.user_answer==0){
                                            icon.cuowu = value.user_answer==value.question_info.question_options[0].is_true?this.icons.icondui:this.icons.iconcuo
                                        }
                                        value.icons = icon
                                        value.suggest_answer = value.question_info.question_options[0].is_true?'正确':'错误'
                                    }
                                    //填空题
                                    if(value.question_info.question_type==4){
                                        value.user_answer = new Array(value.question_info.question_options.length);
                                        let sug = []
                                        value.question_info.question_options.forEach((function(item,index,arr) { 
                                            sug.push(item.options)
                                        }))
                                        value.suggest_answer = sug.toString()
                                        value.user_answer = value.question_info.user_question_answer
                                    }
                                    //问答题
                                    if(value.question_info.question_type==5){
                                        // value.user_answer = {}
                                        // value.user_answer.type = 1
                                        
                                        // value.user_answer.audio = ''
                                        // value.user_answer.text = ''
                                        value.user_answer = value.question_info.user_question_answer
                                        // value.user_answer.images = [
                                        //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                                        //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                                        //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                                        //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                                        //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                                        // ]
                                    }
                                    
                                });
                                console.log(datas.test_info)
                                this.test_questions = datas.test_info
                            }else{
                                this.test_empty = 2
                            }
                            
                        }
                    })
                })
            }
        },
    };
    
</script>

<style scoped>
    
    body{
        background-color: #ffffff;
    }
    .testing .header_wrap{
        height: 230px;
        width: 100%;
        background-color: #ffffff;
    }
    .testing .avatar img{
        margin-top: 15px;
        width: 60px;
        height: 60px;
        border-radius: 30px;
    }
    .testing .test_tips{
        margin-top: 10px;
        color: #8e8d8d;
    }
    .test_grade_score{
        font-size: 35px;
        font-weight: 600;
    }
    .test_grade_commenting{
        font-size: 30px;
        font-weight: 600;
    }
    .test_grade{
        padding: 15px;
        min-height: 40px;
    }
    .test_commit_time{
        font-size: 12px;
        color: #aba9a9;
    }
    .text_center{
        text-align: center;
    }

    .testing .header_wrap_content{
        padding: 15px 30px;
    }
    .testing .header_wrap_item_1{
        width: 72px;
        height: 40px;
        text-align: center;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .testing .header_wrap_text_1{
        font-size: 12px;
    }
    .color_red{
        color: red;
    }
    .color_green{
        color: green;
    }
    .content{
        padding: 18px 15px 20px 15px;
    }
    .content .question_item{
        background-color:  #ffffff;
        padding: 18px 15px 25px 15px;
        border-radius: 5px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
        margin-bottom: 15px;
    }
    .question_item_title{
        display: flex;
    }
    .question_item_seq{
        width: 25px;
    }
    .question_item_topic{
        line-height: 25px;
    }
    .question_item_type{
        padding-left: 8px;
        color: #CCC;
    }
    .van-radio{
        margin-top: 20px;
    }
    .van-checkbox{
        margin-top: 20px;
    }
    .van-field{
        margin-top: 5px;
        padding-left: 0px;
    }
    .question_essay{
        display: flex;
    }
    .question_essay_type_2{
        display: flex;
        box-sizing:border-box;
        flex-wrap: wrap;
    }
    .iconfont_wrap{
        padding: 5px;
    }
    .size25{
        font-size: 25px;
    }
    .size35{
        font-size: 35px;
    }
    .essay_item_wrap{
        width: 23%;
        height: 20vw;
        padding: 5px 1%;
    }
    .essay_item_wrap img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .add_img_button{
        width: 100%;
        height: 100%;
        background-color: #CCC;
        display: flex;
        justify-content:center;
        align-items:center;
        color: aliceblue;
        cursor: pointer;
    }
    .question_item_option{
        display: flex;
    }
    .question_item_option span{
        margin-top: 20px;
        margin-right: 10px;
    }
    .icondui{
        color: rgb(59, 228, 59);
    }
    .iconcuo{
        color: red;
    }
    .font_size_11{
        font-size: 11px;
        color: #ccc;
    }
    .question_result_tips{
        font-size: 16px;
    }
    .question_result_scores{
        padding-left: 5px;
    }
    .question_text_weight{
        font-weight: 600;
        padding-bottom: 5px;
    }
    .question_refer{
        padding: 12px 0px;
    }
    .question_teacher_comment{
        font-size: 16px;
        color: #f57932;
    }
</style>
